// extracted by mini-css-extract-plugin
export default {"description":"AllUserChatItems_description__lvKoK"};